import { Observable } from 'rxjs';
import { SupportStorage } from '../cargo-driver-check-in-model';
import { IndexedDBStorageClass } from './indexed-db';

export class LocalWebStorage implements SupportStorage {
    db: IndexedDBStorageClass;

    constructor() {
        if (this.supportIndexedDBStorage()) {
            this.db = new IndexedDBStorageClass();
        }
    }

    supportIndexedDBStorage() {
        return !!window.indexedDB;
    }

    createDatabase(dbName: string): Observable<string> {
        return this.db.createDatabase(dbName);
    }

    getDatabase<T>(dbName: string): Observable<T[]> {
        return this.db.getDatabase(dbName);
    }

    deleteDatabaseItem(dbName: string, key: string): Observable<string> {
        return this.db.deleteDatabaseItem(dbName, key);
    }

    writeInDatabase(objectStore: string, dbName: string): Observable<string> {
        return this.db.writeInDatabase(objectStore, dbName);
    }
}